import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'bpw-qr-dashboardcard',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './qr-dashboardcard.component.html',
  styleUrls: ['./qr-dashboardcard.component.scss'],
})
export class QrDashboardcardComponent {}
